export default __webpack_public_path__ + "static/media/sharepoint2.1511064a.png";